import type { Interpolation } from "@emotion/react";

export const fade: Record<
  "base" | "entered" | "entering" | "exited" | "exiting",
  Interpolation
> = {
  base: {
    position: "absolute",
    transitionProperty: "opacity",
    willChange: "opacity",
  },
  entered: {
    opacity: 1,
    position: "relative",
  },
  entering: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
  exiting: {
    opacity: 0,
    position: "relative",
  },
};
